module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner qukEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [(_vm.params.id) ? _c('span', [_vm._v("编辑快捷回复")]) : _c('span', [_vm._v("新建快捷回复")])]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules,
      "inline-message": "true",
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [_c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("标签")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "tags"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入回复标签"
    },
    model: {
      value: (_vm.params.tags),
      callback: function($$v) {
        _vm.$set(_vm.params, "tags", $$v)
      },
      expression: "params.tags"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("问题")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "question"
    }
  }, [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入问题内容"
    },
    model: {
      value: (_vm.params.question),
      callback: function($$v) {
        _vm.$set(_vm.params, "question", $$v)
      },
      expression: "params.question"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("回答")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "answer"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "size": "medium",
      "placeholder": "请输入问题内容"
    },
    model: {
      value: (_vm.params.answer),
      callback: function($$v) {
        _vm.$set(_vm.params, "answer", $$v)
      },
      expression: "params.answer"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [(_vm.tabArr.length > 0) ? _c('table', {
    staticClass: "pocTab"
  }, [_c('tr', [_c('td', {
    staticClass: "tSpan1"
  }, [_vm._v("标题")]), _c('td', {
    staticClass: "tSpan2"
  }, [_vm._v("操作")])]), _vm._v(" "), _vm._l((_vm.tabArr), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "tSpan1"
    }, [_vm._v(_vm._s(item.description))]), _c('td', {
      staticClass: "tSpan2"
    }, [_c('span', {
      staticClass: "ibtn",
      on: {
        "click": function($event) {
          _vm.goRemove(index)
        }
      }
    }, [_vm._v("删除")])])])
  })], 2) : _vm._e()])])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [(_vm.pgState) ? _c('div', {
    staticClass: "loading"
  }, [(_vm.pgState == 3) ? _c('span', [_vm._v("初始化中...")]) : _vm._e(), _vm._v(" "), (_vm.pgState == 4) ? _c('span', [_vm._v("数据保存中...")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.directSave(1)
      }
    }
  }, [_vm._v("保存并发布")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("取消")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-bd3f2a46"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/banner/qukEdit.vue
// module id = 1553
// module chunks = 1